module.exports = __webpack_public_path__ + "img/logo.e41e3c59.png";